import React, { ReactElement, useState, useEffect } from "react";
import { BackNavigationContext, BackNavigation } from "@checkout-core/contexts/BackNavigationContext";
import { GlobalHeaderState } from "@checkout-core/utils/Headers";
import { SwgyHeaderKeysList } from "@swiggy-private/checkout-types";
import { isEmpty } from "@swiggy-private/js-utils";

export function BackNavigationContextProvider(props: { children: React.ReactNode }): ReactElement {
    const [backAction, setBackAction] = useState<BackNavigation>({ deeplink: null, screenName: null });

    useEffect(() => {
        // Extract backAction from headers on mount
        try {
            const headerBackAction = GlobalHeaderState.getHeader(SwgyHeaderKeysList.backAction);
            const headerScreenName = GlobalHeaderState.getHeader(SwgyHeaderKeysList.backActionScreenName);

            if (!isEmpty(headerBackAction) && !isEmpty(headerScreenName)) {
                setBackAction({ deeplink: headerBackAction, screenName: headerScreenName });
                // Remove the header to prevent downstream services from getting affected
                GlobalHeaderState.removeHeader(SwgyHeaderKeysList.backAction);
                GlobalHeaderState.removeHeader(SwgyHeaderKeysList.backActionScreenName);
            }
        } catch (error) {
            // Header doesn't exist or failed to get, continue with null
        }
    }, []);

    const contextValue = React.useMemo(
        () => ({
            backAction,
            setBackAction,
        }),
        [backAction],
    );

    return <BackNavigationContext.Provider value={contextValue}>{props.children}</BackNavigationContext.Provider>;
}
